<template>
  <div v-if="visible" class="scanbox-overlay" :style="{ zIndex: overlayZIndex }">
    <div class="scanbox-modal">
      <div class="scanbox-close"  @click="$emit('close')">
        <img  src="@/assets/payClose.png" alt="">
      </div>
      <!-- 标题 -->
      <h3 class="scanbox-title">扫码小白盒</h3>

      <!-- 扫码结果展示 -->
      <div class="scanbox-content">
        <p v-if="scanResult">识别结果：{{ scanResult }}</p>
        <p v-else class="placeholder">请将二维码对准扫码器...</p>
      </div>

      <!-- 支付状态展示 -->
      <div class="scanbox-status" :class="statusClass">
        {{ statusText }}
      </div>

      <!-- 倒计时显示 -->
      <div v-if="countdown > 0" class="countdown">
        剩余时间：<span class="countdown-number">{{ countdown }}</span>s
      </div>

      <!-- 底部按钮 -->
<!--      <div class="scanbox-footer">-->
<!--        <button class="btn cancel" @click="$emit('close')">取消</button>-->
<!--        <button class="btn pay" disabled>-->
<!--          发起支付-->
<!--          <span v-if="countdown > 0"> ({{ countdown }}s)</span>-->
<!--        </button>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import { useZIndex } from 'element-plus'

export default {
  name: "ScanBox",
  setup() {
    const { nextZIndex } = useZIndex();
    return {
      nextZIndex,
    };
  },
  props: {
    visible: { type: Boolean, default: false },
    status: { type: String, default: "" }, // "" | P | S | F
    countdownSeconds: { type: Number, default: 60 },
  },
  data() {
    return {
      scanResult: "",
      buffer: "",
      lastKeyTime: 0,        // 上一次按键时间
      maxInterval: 50,
      countdown: 0,
      pollTimer: null,
      countdownTimer: null,
      overlayZIndex: 0,
    };
  },
  computed: {
    statusText() {
      switch (this.status) {
        case "P": return "支付中...";
        case "S": return "支付成功";
        case "F": return "支付失败";
        default:  return "等待扫码";
      }
    },
    statusClass() {
      switch (this.status) {
        case "P": return "pending";
        case "S": return "success";
        case "F": return "fail";
        default: return "";
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.refreshOverlayZIndex();
        window.addEventListener("keydown", this.handleKeydown);
      } else {
        window.removeEventListener("keydown", this.handleKeydown);
        this.resetState();
      }
    },
    status(newStatus,oldStatus) {
      if (newStatus === "P") {
        // this.startPolling();
      } else if (newStatus === "S" || newStatus === "F") {
        this.resetState();
      }
    }
  },
  methods: {
    refreshOverlayZIndex() {
      this.overlayZIndex = this.nextZIndex();
      console.log('this.overlayZIndex',this.overlayZIndex)
    },

    /** 扫码枪输入优化：只识别快速连续输入 + Enter */
    handleKeydown(e) {
      if (!this.visible) return;
      const now = Date.now();

      if (e.key !== "Enter" && e.key.length !== 1) {
        return;
      }

      if (e.key === "Enter") {
        if (this.buffer) {
          this.scanResult = this.buffer;
          this.buffer = "";
          this.$emit("scanned", this.scanResult);
          this.$emit("pay", this.scanResult); // 不受影响
        }
        return;
      }

      if (now - this.lastKeyTime > this.maxInterval) {
        this.buffer = "";
      }

      if (/^[\w\d\-_.]$/.test(e.key)) {
        this.buffer += e.key;
      }

      this.lastKeyTime = now;
    },

    /** 开始倒计时 */
    startCountdown() {
      this.clearCountdown();
      this.countdown = this.countdownSeconds;
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.clearCountdown();
          this.$emit("timeout");
        }
      }, 1000);
    },

    /** 开始轮询 */
    startPolling() {
      this.clearPolling();
      this.pollTimer = setInterval(() => {
        this.$emit("poll", this.scanResult);
      }, 3000);
    },

    /** 停止轮询 */
    clearPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },

    /** 停止倒计时 */
    clearCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },

    /** 清理所有定时器 */
    clearTimers() {
      this.clearPolling();
      this.clearCountdown();
    },

    /** 重置状态 */
    resetState() {
      this.buffer = "";
      this.scanResult = "";
      this.countdown = 0;
      this.clearTimers();
    },
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeydown);
    this.clearTimers();
  }
};
</script>

<style scoped>
.scanbox-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.scanbox-modal {
  position: relative;
  width: 420px;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  box-shadow: 0 6px 24px rgba(0,0,0,0.25);
}
.scanbox-close{
  position: absolute;
  right: 20px;
  cursor: pointer;
  width: 10px;
  height: 10px;
}
.scanbox-close>img{
  width: 100%;
  height: 100%;
}

.scanbox-title {
  font-size: 22px;
  margin-bottom: 15px;
  font-weight: bold;
}

.scanbox-content {
  margin-bottom: 15px;
  font-size: 16px;
  min-height: 30px;
}

.placeholder { color: #999; }

.scanbox-status {
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0 15px;
}

.scanbox-status.success {
  color: green;
}

.scanbox-status.fail {
  color: red;
}

.scanbox-status.pending {
  color: orange;
}


.countdown {
  margin: 10px 0 20px;
  font-size: 20px;
  font-weight: bold;
  color: #ff4d4f;
}
.countdown-number {
  font-size: 28px;
  font-weight: 900;
  color: #ff0000;
  padding: 0 5px;
  background: #fff1f0;
  border-radius: 6px;
  border: 1px solid #ffccc7;
}

.scanbox-footer {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}

.btn {
  padding: 8px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  border: none;
}

.btn.cancel {
  background: #ddd;
}

.btn.pay {
  background: #67c23a;
  color: #fff;
}

.btn.pay:disabled {
  background: #bbb;
  cursor: not-allowed;
}
</style>
